export const AudienceGroupAssetGroupAssociation = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Audience Group Asset Group Association',
    },
    AudienceGroupId: {
      'bulk-upload-header': 'Id',
    },
    AssetGroupId: {
      'bulk-upload-header': 'Parent ID',
    },
    Status: {
      'bulk-upload-header': 'Status',
    },
  },
};
